import React from "react";
import { useDispatch } from "react-redux";
import { updateAppointment } from "../redux/slices/appointmentSlice";
import { AppDispatch } from "../redux/store";
import { AppointmentState } from "../types";
import {
  buttonPrimary,
  buttonSecondary,
  cardHeaderClass,
  cardBodyClass,
} from "css";

interface RideOptionPickerProps {
  appointment: AppointmentState;
  complimentaryRide: string;
  setComplimentaryRide: (ride: string) => void;
  bounceComplimentaryRide: boolean;
  setBounceComplimentaryRide: (bounce: boolean) => void;
  setClear: (clear: boolean) => void;
}

export const RideOptionPicker: React.FC<RideOptionPickerProps> = ({
  appointment,
  complimentaryRide,
  setComplimentaryRide,
  bounceComplimentaryRide,
  setBounceComplimentaryRide,
  setClear,
}) => {
  const dispatch = useDispatch<AppDispatch>();

  return (
    <>
      <div
        id="ride-picker"
        className={`${cardHeaderClass} flex justify-between`}
        style={{ backgroundColor: appointment?.shopData?.color }}
      >
        Will you need a complimentary ride?
        <span className="relative flex h-3 w-3 pt-1.5">
          {bounceComplimentaryRide ? (
            <>
              <span className="relative inline-flex rounded-full h-3 w-3 bg-green-600"></span>
            </>
          ) : (
            <>
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-3 w-3 bg-red-600"></span>
            </>
          )}
        </span>
      </div>
      <div
        className={cardBodyClass}
        style={{ borderColor: appointment?.shopData?.color }}
      >
        <div className="grid grid-cols-2 gap-5 p-2">
          {["Yes", "No"].map((choice) => (
            <div
              key={choice}
              onClick={() => {
                dispatch(
                  updateAppointment({
                    updates: { complimentaryRide: choice },
                  })
                );
                setComplimentaryRide(choice);
                setBounceComplimentaryRide(true);
                if (!appointment?.shopData?.requireComments) {
                  setClear(true);
                }
              }}
            >
              <center>
                <div
                  className={`size-20 md:w-[160px] md:h-[80px] p-2 ${
                    choice === complimentaryRide
                      ? buttonSecondary
                      : buttonPrimary
                  }`}
                  style={{
                    cursor: "pointer",
                    backgroundColor:
                      choice === complimentaryRide
                        ? appointment?.shopData?.color
                        : "white",
                    border: `1px solid ${appointment?.shopData?.color}`,
                    boxShadow:
                      appointment?.shopData?.shadow === "shadow-md"
                        ? `0 4px 6px ${appointment?.shopData?.color}33`
                        : "none",
                  }}
                >
                  {choice}
                </div>
              </center>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};
